<template>
  <main
    id="guide-page"
    class="guide-page"
    ref="host"
    :style="{ height: frameHeight }"
  >
    <iframe
      :src="guideUrl"
      class="guide-iframe"
      title="Manuale operativo Barcio"
    ></iframe>
  </main>
</template>

<script>
export default {
  name: "GuideView",
  data() {
    return { topOffset: 0 };
  },
  computed: {
    guideUrl() {
      const userLang = this.$i18n?.locale || navigator.language.split("-")[0];
      const manualFile = userLang === "en" ? "manuale_en.html" : "manuale.html";
      return `/docs/guide/${manualFile}`;
    },
    // Riempie esattamente la viewport sotto la top-bar: niente scroll esterno
    frameHeight() {
      return `calc(100dvh - ${this.topOffset}px)`;
    },
  },
  mounted() {
    this.measure();
    window.addEventListener("resize", this.measure);
  },
  unmounted() {
    window.removeEventListener("resize", this.measure);
  },
  methods: {
    measure() {
      const el = this.$refs.host;
      if (!el) return;
      // distanza dal top del documento = altezza della top-bar (responsive)
      this.topOffset = el.getBoundingClientRect().top + window.scrollY;
    },
  },
};
</script>

<style scoped>
main#guide-page.guide-page {
  display: flex;
  width: 100%;
  padding: 0;
  margin: 0;
  background: #f9f9f9;
  overflow: hidden;
}

.guide-iframe {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 0;
  padding: 0;
  margin: 0;
}
</style>
